export type ActionTargetType = 'applicant' | 'contact'

export type TargetActionName =
  | 'call'
  | 'message'
  | 'email'
  | 'meeting'
  | 'addToOrder'
  | 'note'
  | 'etesting'

const ACTIONS_BY_TARGET: Record<ActionTargetType, TargetActionName[]> = {
  applicant: [
    'call',
    'message',
    'email',
    'meeting',
    'addToOrder',
    'note',
    'etesting'
  ],
  contact: ['call', 'message', 'email', 'meeting', 'note']
}

export const actionsForTarget = (
  type: ActionTargetType,
  hiddenActions: TargetActionName[] = []
): TargetActionName[] =>
  ACTIONS_BY_TARGET[type].filter((action) => !hiddenActions.includes(action))
